import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs';
import { DataProviderRegistry } from '@lib.core/data-provider/registry';
import { RegisteredDataProviders } from '@lib.core/data-provider/registered-data-providers';
import { ServiceRegistry } from '@lib.shared/service-registry/service-registry';
import { ResourceRegistry } from '@lib.resources/resource-registry/resource-registry';
import { AspectStore } from '@lib.resources/indicator/indicator.store';
import { ProfileStore } from '@lib.resources/profile/profile.store';
import { LocationCompositeAdapter } from '@lib.resources/data-provider-adapters/location-composite/location-composite.adapter';
import { EnvironmentAccessService } from '@public/src/app/services/environment-access.service';
import { ClientIdStorageService } from '@public/src/app/store/store-access/client-id-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceRegistrar {
  private readonly environmentAccessService = inject(EnvironmentAccessService);
  private readonly resourceRegistry = inject(ResourceRegistry);
  private readonly coreDataProviderRegistry = inject(DataProviderRegistry<unknown>);
  private readonly locationCompositeAdapter = inject(LocationCompositeAdapter);
  private readonly clientIdStore = inject(ClientIdStorageService);

  constructor(
    private sharedLibServiceRegistry: ServiceRegistry,
    private aspectResource: AspectStore,
    private profileService: ProfileStore,
  ) {
  }

  register() {
    this.setClientId();
    this.sharedLibServiceRegistry.setAspectService(this.aspectResource);
    this.sharedLibServiceRegistry.setProfileService(this.profileService);
    this.resourceRegistry.setEnvironmentResource(this.environmentAccessService);
    this.sharedLibServiceRegistry.setEnvironmentService(this.environmentAccessService);
    this.coreDataProviderRegistry.setDataProvider(RegisteredDataProviders.LocationComposite, this.locationCompositeAdapter);
  }

  private setClientId() {
    this.clientIdStore.getClientId()
      .pipe(take(1))
      .subscribe((clientId) => {
        this.locationCompositeAdapter.setClientId(clientId);
      });
  }
}
